import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class Logo extends Component {
  state = {
    animColorYellow: false,
    animColorGreen: false,
    animColorBlue: false,
    animColorOrange: false,
    animColorRed: false,
    animColorPurple: false,
  };

  render() {
    // setTimeout(
    //   () =>
    //     this.setState({
    //       animColorYellow: !this.state.animColorYellow,
    //     }),
    //   1000

    console.log(this.state.animColorYellow);
    return (
      <>
        <div className="logo">
          {/* mise en palce et animation du titre  */}
          <div className="container">
            {/* on effectue un changement de class au bout d'un timer */}
            <NavLink exact to="/connect">
              <img
                className="textLogoWhite"
                src="../../media/img/TG-Logo-text-noir.png"
                alt="text logo think Greater"
              />
            </NavLink>
            <img
              id="animColorYellow"
              className={
                this.state.animColorYellow
                  ? "colorLogoLight"
                  : "colorLogoLight animColorYellow"
              }
              src="../../media/img/TG-Logo-yellow.png"
              alt="vague crayonnée jaune"
            />

            <img
              id="animColorGreen"
              className={
                this.state.animColorGreen
                  ? "colorLogoLight"
                  : "colorLogoLight animColorGreen"
              }
              src="../../media/img/TG-Logo-green.png"
              alt="vague crayonnée verte"
            />
            <img
              id="animColorBlue"
              className={
                this.state.animColorBlue
                  ? "colorLogoLight"
                  : "colorLogoLight animColorBlue"
              }
              src="../../media/img/TG-Logo-blue.png"
              alt="vague crayonnée blue"
            />
            <img
              id="animColorOrange"
              className={
                this.state.animColorOrange
                  ? "colorLogoLight"
                  : "colorLogoLight animColorOrange"
              }
              src="../../media/img/TG-Logo-orange.png"
              alt="vague crayonnée orange"
            />
            <img
              id="animColorRed"
              className={
                this.state.animColorRed
                  ? "colorLogoLight"
                  : "colorLogoLight animColorRed"
              }
              src="../../media/img/TG-Logo-red.png"
              alt="vague crayonnée rouge"
            />
            {/* test page connection */}

            <img
              id="animColorPurple"
              className={
                this.state.animColorPurple
                  ? "colorLogoLight"
                  : "colorLogoLight animColorPurple"
              }
              src="../../media/img/TG-Logo-purple.png"
              alt="vague crayonnée violet"
            />
          </div>
          {/* test bouon changement de class */}
          <div
          // className={
          //   // toggle la class
          // }
          ></div>
          {/* fin de test */}
          <div className="slogan">
            <p>Penser grand pour aller plus loin</p>
          </div>
        </div>
      </>
    );
  }
}
export default Logo;
